import * as Sentry from '@sentry/react';
import { AddInError } from '../addInError';
import { logError } from './logger';

export const handleError = (error: AddInError, callback?: () => any) => {
  logError('Add-in error caught: ', { error, serializedError: JSON.stringify(error) });
  Sentry.captureException(
    error,
    error?.context ? { contexts: { 'Error Details': error.context } } : undefined,
  );
  if (callback) callback();
};
